import { render, staticRenderFns } from "./Product-Purchases.vue?vue&type=template&id=8a2adca2&scoped=true"
import script from "./Product-Purchases.vue?vue&type=script&lang=js"
export * from "./Product-Purchases.vue?vue&type=script&lang=js"
import style0 from "./Product-Purchases.vue?vue&type=style&index=0&id=8a2adca2&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8a2adca2",
  null
  
)

export default component.exports